import React, { SVGProps } from 'react'
const SvgAlertCircled = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || '#EB505B'} fillRule="nonzero">
      <path d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75Zm0-1.5a8.25 8.25 0 1 1 0-16.5 8.25 8.25 0 0 1 0 16.5Z" />
      <path d="M11.165 7.01a.75.75 0 0 1 1.5 0v7.175a.75.75 0 0 1-1.5 0V7.01Zm0 9.992a.75.75 0 0 1 1.5 0v.423a.75.75 0 0 1-1.5 0v-.423Z" />
    </g>
  </svg>
)
export default SvgAlertCircled
